import React from "react";
import logo from "../assets/logo/LOGO.png";
import img1 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.36.jpeg";
import img2 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.42 (2).jpeg";
import img3 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.40.jpeg";
import img4 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.42 (1).jpeg";

export default function Hero() {
  return (
    <section
      id="home"
      className="relative min-h-screen pt-24 sm:pt-28 pb-16 flex items-center overflow-hidden bg-gradient-to-br from-white via-cream to-gray-100"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-40 -left-40 w-96 h-96 rounded-full bg-gold/10 blur-3xl" />
        <div className="absolute -bottom-40 -right-40 w-[32rem] h-[32rem] rounded-full bg-maroon/10 blur-3xl" />
        <svg
          className="absolute inset-0 w-full h-full opacity-[0.04]"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <pattern
              id="dot"
              width="32"
              height="32"
              patternUnits="userSpaceOnUse"
            >
              <circle cx="2" cy="2" r="1.2" fill="#800000" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#dot)" />
        </svg>
      </div>

      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 md:px-10 grid lg:grid-cols-12 gap-10 lg:gap-12 items-center w-full">
        <div className="lg:col-span-6 animate-fadeUp text-center lg:text-left">
          <div className="inline-flex items-center gap-3 px-4 py-2 rounded-full bg-white border border-gold/40 shadow-sm mb-5">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-gold opacity-75" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-gold" />
            </span>
            <span className="text-[11px] sm:text-xs uppercase tracking-[0.3em] text-maroon font-semibold">
              Visnagar's Trusted Jeweller
            </span>
          </div>

          <h1 className="font-serif text-[2.25rem] sm:text-5xl md:text-6xl lg:text-[4.25rem] leading-[1.05] text-maroon font-bold">
            Where Every Ornament
            <br className="hidden sm:block" />
            <span className="gold-gradient-text">Tells a Story.</span>
          </h1>

          <p className="mt-5 sm:mt-6 text-sm sm:text-base md:text-lg text-gray-700 max-w-xl mx-auto lg:mx-0 leading-relaxed">
            From sacred bridal haars to delicate everyday elegance,{" "}
            <span className="text-maroon font-semibold">
              Shivkumar Jewellers
            </span>{" "}
            crafts heirlooms in 22K gold, 925 silver and fine diamonds
            treasures that carry tradition from one generation to the next.
          </p>

          <div className="mt-7 sm:mt-8 flex flex-wrap justify-center lg:justify-start gap-3 sm:gap-4">
            <a
              href="#catalogue"
              className="inline-flex items-center gap-2 bg-maroon text-white px-6 sm:px-7 py-3 rounded-full font-medium shadow-lg hover:bg-maroon-dark transition-colors text-sm sm:text-base"
            >
              Explore Catalogue
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </a>
            <a
              href="#about"
              className="inline-flex items-center gap-2 border-2 border-gold text-gold-dark px-6 sm:px-7 py-3 rounded-full font-medium hover:bg-gold hover:text-white transition-colors text-sm sm:text-base"
            >
              Our Story
            </a>
          </div>

          <div className="mt-9 sm:mt-10 grid grid-cols-3 gap-3 sm:gap-4 max-w-md mx-auto lg:mx-0">
            <Stat number="90+" label="Years of Trust" />
            <Stat number="5" label="Generations" />
            <Stat number="1933" label="Established" />
          </div>
        </div>

        <div className="lg:col-span-6 relative animate-fadeUp">
          <div className="relative mx-auto max-w-md lg:max-w-none w-full aspect-[4/5] sm:aspect-[5/6] lg:aspect-[4/5]">
            <div className="absolute top-0 right-0 w-3/5 h-3/5 rounded-3xl overflow-hidden shadow-2xl border-4 border-white rotate-2 hover:rotate-0 transition-transform duration-500">
              <img
                src={img1}
                alt="Bridal Kundan Set"
                className="w-full h-full object-cover"
              />
            </div>

            <div className="absolute bottom-0 left-0 w-1/2 h-1/2 rounded-3xl overflow-hidden shadow-2xl border-4 border-white -rotate-3 hover:rotate-0 transition-transform duration-500 z-10">
              <img
                src={img2}
                alt="Bridal Choker"
                className="w-full h-full object-cover"
              />
            </div>

            <div className="absolute top-1/4 left-0 w-2/5 h-2/5 rounded-3xl overflow-hidden shadow-xl border-4 border-white rotate-6 hover:rotate-0 transition-transform duration-500">
              <img
                src={img3}
                alt="Rani Haar"
                className="w-full h-full object-cover"
              />
            </div>

            <div className="absolute bottom-1/4 right-0 w-2/5 h-2/5 rounded-3xl overflow-hidden shadow-xl border-4 border-white -rotate-6 hover:rotate-0 transition-transform duration-500 z-10">
              <img
                src={img4}
                alt="Gold Necklace Set"
                className="w-full h-full object-cover"
              />
            </div>

            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-28 h-28 sm:w-32 sm:h-32 md:w-36 md:h-36 rounded-full bg-maroon-dark ring-[6px] ring-white shadow-2xl border-4 border-gold flex items-center justify-center z-20">
              <img
                src={logo}
                alt="SMS Gold Logo"
                className="w-[85%] h-[85%] object-contain"
              />
            </div>

            <div className="hidden sm:block absolute -top-4 left-6 bg-white px-4 py-2 rounded-full shadow-lg border border-gold/40 z-30">
              <div className="flex items-center gap-2">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="#c9a227" stroke="#c9a227" strokeWidth="1">
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
                <span className="text-xs font-semibold text-maroon">
                  BIS Hallmarked
                </span>
              </div>
            </div>

            <div className="hidden sm:block absolute -bottom-3 right-6 bg-white px-4 py-2 rounded-full shadow-lg border border-gold/40 z-30">
              <span className="text-xs font-semibold text-maroon tracking-wider">
                Est. Visnagar
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 bg-maroon text-gold overflow-hidden border-t border-gold/30">
        <div className="flex whitespace-nowrap animate-marquee py-3 gap-12">
          {[...Array(2)].map((_, i) => (
            <div key={i} className="flex items-center gap-12 text-sm">
              <MarqueeItem text="22K Pure Gold" />
              <MarqueeItem text="BIS Hallmarked" />
              <MarqueeItem text="925 Sterling Silver" />
              <MarqueeItem text="Bridal Specialists" />
              <MarqueeItem text="Gold Exchange Available" />
              <MarqueeItem text="Custom Designs" />
              <MarqueeItem text="Certified Diamonds" />
              <MarqueeItem text="Visnagar, Gujarat" />
              <MarqueeItem text="22K Pure Gold" />
              <MarqueeItem text="BIS Hallmarked" />
              <MarqueeItem text="925 Sterling Silver" />
              <MarqueeItem text="Bridal Specialists" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Stat({ number, label }) {
  return (
    <div className="border-l-2 border-gold pl-3 sm:pl-4">
      <div className="font-serif text-xl sm:text-2xl md:text-3xl font-bold text-maroon">
        {number}
      </div>
      <div className="text-[10px] sm:text-[11px] md:text-xs uppercase tracking-wider text-gray-600 mt-1">
        {label}
      </div>
    </div>
  );
}

function MarqueeItem({ text }) {
  return (
    <div className="flex items-center gap-3 text-gold">
      <svg width="12" height="12" viewBox="0 0 24 24" fill="#c9a227">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
      </svg>
      <span className="uppercase tracking-[0.25em] text-xs sm:text-sm font-medium">
        {text}
      </span>
    </div>
  );
}
